import React from "react";
import { Avatar, AvatarGroup, Box, Tooltip, useTheme } from "@mui/material";
import { getAvatarColor } from "helpers/avatarHelpers";

/**
 * Component to display co-viewers as avatars
 * @param {{ viewers: Array<{ userId: number, name: string, imageThumbnail: string }> }} props
 */
const PresenceIndicator = ({ viewers }) => {
  const theme = useTheme();
  
  if (!viewers || viewers.length === 0) return null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
      <AvatarGroup
        max={4}
        spacing={0}
        renderSurplus={(surplus) => (
          <Tooltip title={`${surplus} more viewing`} arrow placement="bottom">
            <Avatar sx={{ bgcolor: theme.palette.primary.main }}>+{surplus}</Avatar>
          </Tooltip>
        )}
        sx={{
          gap: 0.75,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            fontSize: "0.875rem",
            borderRadius: "12px",
            bgcolor: theme.palette.primary.main,
            boxShadow: theme.shadows[3],
            border: "none",
          },
          "& .MuiAvatarGroup-avatar": {
            width: 32,
            height: 32,
            border: "none",
          },
        }}
      >
        {viewers.map((viewer) => (
          <Tooltip
            key={viewer.userId}
            title={
              viewer.entityType === "SettingsTab" && viewer.entityId
                ? `${viewer.name} is viewing Settings > ${viewer.entityId}`
                : `${viewer.name} is viewing this`
            }
            arrow
            placement="bottom"
          >
            <Avatar
              src={viewer.imageThumbnail}
              alt={viewer.name}
              sx={{ bgcolor: getAvatarColor(viewer.name) }}
            >
              {viewer.name?.charAt(0)?.toUpperCase()}
            </Avatar>
          </Tooltip>
        ))}
      </AvatarGroup>
    </Box>
  );
};

export default PresenceIndicator;
